import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Sort from "../../components/Sort";
import FormField from "../../components/FormField";
import GameList from "../../components/GameList";

import { filterGames } from "../../actions/actions";
import FilterMode from "../../components/FilterMode";

class Games extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterGamesBy: "",
    };
  }

  onFilterGamesChange = function (_, value) {
    this.setState({ filterGamesBy: value });

    this.props.filterGames(value);
  };

  render() {
    const { games, isFetching } = this.props;

    return (
      <div>
        {!isFetching && (
          <div className="container col-md-12">
            <FormField
              configID="filter"
              label="Filter Games"
              type="text"
              placeholder={"Filter..."}
              onChange={this.onFilterGamesChange.bind(this)}
              value={this.state.filterGamesBy}
              debounceDelay={300} // only fires 300ms after typing stops
            />
          </div>
        )}

        {isFetching && (
          <h2>
            Loading<span className="dots"></span>
          </h2>
        )}

        {!isFetching && (
          <div className="container col-md-12">
            <div className="row">
              <div className="col-sm-6 col-md-6">
                <FilterMode />
              </div>
              <div className="col-sm-6 col-md-6">
                <Sort />
              </div>
            </div>
          </div>
        )}

        <div className="container col-md-12" role="main">
          <GameList
            games={games}
            config={this.props.config}
            urlLaunchOptions={this.props.urlLaunchOptions}
            launchOptions={this.props.launchOptions}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const currentState = state.environment_information;

  let games = currentState.get("filteredGames");
  const filterMode = currentState.get("filterMode");

  switch (filterMode) {
    case "real": {
      games = games.filter((game) => game.get("interface") === "dev-wallet");
      break;
    }
    case "demo": {
      games = games.filter((game) => game.get("interface") === "demo-wallet");
      break;
    }
    default:
      break;
  }

  const config = currentState.get("config");
  const launchOptions = currentState.get("launchOptions");
  const urlLaunchOptions = currentState.get("urlLaunchOptions");
  const isFetching = currentState.get("isFetching");

  return {
    games,
    config,
    isFetching,
    launchOptions,
    urlLaunchOptions,
  };
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    filterGames: (filter) => dispatch(filterGames(filter)),
  };
};

Games.propTypes = {
  isFetching: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(Games);



// WEBPACK FOOTER //
// ./src/pages/Games/Games.jsx